import { Typography, Grid, Paper } from '@mui/material';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { drawerWidth, ticketBarHeight } from '..';
import { VEHICLES } from '../../../routes';
import { fetchAnyIrregularity, useDispatch, useSelector } from '../../../stores';
import { palette } from '../../../theme';
import { Button } from '../../Button';

export const IrregularitiesBar: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { driverId } = useSelector((state) => state.profileReducer);
  const { ticketTimeLeft, ticketRenovate } = useSelector(
    (state) => state.ticketPurchaseReducer,
  );
  const { hasAnyIrregularity } = useSelector(
    (state) => state.irregularitiesReducer,
  );

  useEffect(() => {
    if (!driverId) return;
    const params = { driverId: driverId.toString() };

    dispatch(fetchAnyIrregularity(params));

    const handleFocus = () => {
      dispatch(fetchAnyIrregularity(params));
    };

    window.addEventListener('focus', handleFocus);
    return () => window.removeEventListener('focus', handleFocus);
  }, [driverId]);

  if (!hasAnyIrregularity) return null;

  return (
    <Grid
      sx={{
        width: { md: `calc(100% - ${drawerWidth}px)`, xs: '100%' },
        position: 'absolute',
        top: {
          sm: 64,
          xs: 56,
        },
        right: 0,
        borderRadius: 0,
      }}
    >
      <Paper
        sx={{
          backgroundColor: palette.error.main,
          borderRadius: 0,
          height: ticketBarHeight,
          boxShadow: `0px 15px 10px 1px rgba(0, 0, 0, 0.3)`,
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '0 10px',
          gap: 2,
        }}
      >
        <Typography
          color='white'
          sx={{
            fontSize: {
              xs: '12px',
              sm: '14px',
              md: '18px',
            },
          }}
        >
          Você possui irregularidades
        </Typography>
        <Button
          variant='contained'
          label='Ver irregularidades'
          onClick={() => navigate(VEHICLES)}
          color='secondary'
        />
      </Paper>
    </Grid>
  );
};

